<section class="quick-start-editor" [attr.aria-label]="'Quick Starts for ' + localeLabel">
  <div class="quick-start-editor__header">
    <div>
      <h4>{{ localeLabel }} Quick Starts</h4>
      <p>These suggestions appear before the visitor starts a conversation.</p>
    </div>
    <button mat-stroked-button color="primary" type="button" (click)="addSampleMessage()">
      <mat-icon>add</mat-icon>
      Add Quick Start
    </button>
  </div>

  @for (message of sampleMessages.controls; track message; let i = $index) {
    @if (row(i); as messageGroup) {
      <article class="quick-start-card" [formGroup]="messageGroup">
        <div class="quick-start-card__title">
          <strong>Quick Start {{ i + 1 }}</strong>
          <app-disabled-button-reason [disabled]="removeDisabled" [reason]="removeDisabledReason">
            <button mat-icon-button color="warn" type="button"
                    [disabled]="removeDisabled"
                    [attr.aria-label]="'Remove Quick Start ' + (i + 1)"
                    (click)="removeSampleMessage(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </app-disabled-button-reason>
        </div>

        <div class="quick-start-card__fields">
          <mat-form-field appearance="fill">
            <mat-label>Headline</mat-label>
            <input matInput formControlName="headline">
            @if (messageGroup.get('headline')?.invalid && messageGroup.get('headline')?.touched) {
              <mat-error>Headline is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Description</mat-label>
            <textarea matInput rows="2" formControlName="description"></textarea>
            @if (messageGroup.get('description')?.invalid && messageGroup.get('description')?.touched) {
              <mat-error>Description is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Image URL</mat-label>
            <input matInput formControlName="imageUrl" placeholder="https://example.com/category.jpg">
            <mat-hint>Use an existing hosted image or upload one below.</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Image alt text</mat-label>
            <input matInput formControlName="imageAlt" placeholder="Describe the image">
            <mat-hint>Describe the image for visitors using assistive technology.</mat-hint>
          </mat-form-field>
        </div>

        <div class="quick-start-card__image">
          @if (previewUrl(i); as imageUrl) {
            <img [src]="imageUrl" [alt]="messageGroup.get('imageAlt')?.value || 'Quick Start image preview'">
          } @else {
            <div class="quick-start-card__placeholder">No image selected</div>
          }

          <div>
            <div class="quick-start-card__image-actions">
              <button mat-stroked-button color="primary" type="button"
                      [disabled]="isUploading(i)"
                      (click)="imageInput.click()">
                <mat-icon>{{ isUploading(i) ? 'hourglass_top' : 'upload' }}</mat-icon>
                {{ isUploading(i) ? 'Uploading…' : (previewUrl(i) ? 'Replace image' : 'Upload image') }}
              </button>
              <input #imageInput hidden type="file" accept="image/jpeg,image/png,image/webp,image/gif"
                     (change)="uploadImage(i, $event)">
              <button mat-button type="button" [disabled]="!messageGroup.get('imageUrl')?.value || isUploading(i)"
                      (click)="removeImage(i)">
                Remove image
              </button>
            </div>
            <small>JPEG, PNG, WebP or non-animated GIF, up to 2 MB.</small>
          </div>
        </div>
      </article>
    }
  }

  @if (allowSuggestions && allowGenerativeActions) {
    <button mat-stroked-button color="primary" type="button" (click)="suggestExamples()">
      <mat-icon>autorenew</mat-icon>
      Load suggestions
    </button>
  }
</section>
